setTimeout(function() {
  if($('[data-identifier="Breedte links (cm)"]').length) {
    var totalWidth = $('[data-identifier="Afmetingen"]');
  var widthLeft = $('[data-identifier="Breedte links (cm)"]');
  var widthRight = $('[data-identifier="Breedte rechts (cm)"]');
  totalWidth.on('change', function() {
    let totalEnteredWidth = parseInt(widthLeft.val()) + parseInt(widthRight.val())
    if(totalEnteredWidth != totalWidth.val()) {
      $('.add-to-cart').prop('disabled', true);
      $('#width-error').show()
    } else {
      $('.add-to-cart').prop('disabled', false);
      $('#width-error').hide()
    }
  });
  $(document).on('change','[data-identifier="Breedte links (cm)"]',function() {
    let totalEnteredWidth = parseInt(widthLeft.val()) + parseInt(widthRight.val())
    if(totalEnteredWidth != totalWidth.val()) {
      $('.add-to-cart').prop('disabled', true);
      $('#width-error').show()
      $('data-identifier="Breedte links (cm)"').append( "<p id='width-error' class='error-message'>Controleer de breedte links en breedte rechts</p>" );
    } else {
      $('.add-to-cart').prop('disabled', false);
      $('#width-error').hide()
    }
  });
  widthRight.on('change', function() {
    let totalEnteredWidth = parseInt(widthLeft.val()) + parseInt(widthRight.val())
    if(totalEnteredWidth != totalWidth.val()) {
      $('.add-to-cart').prop('disabled', true);
      $('#width-error').show()
    } else {
      $('.add-to-cart').prop('disabled', false);
      $('#width-error').hide()
    }
  });
  }
}, 5000);